import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import CustomRolesHome from './Index.vue';
import CustomRolesNew from './New.vue';
import CustomRolesEdit from './Edit.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-roles'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'custom_roles_list',
          meta: {
            permissions: ['administrator'],
          },
          component: CustomRolesHome,
        },
        {
          path: 'new',
          name: 'custom_roles_new',
          meta: {
            permissions: ['administrator'],
          },
          component: CustomRolesNew,
        },
        {
          path: ':roleId/edit',
          name: 'custom_roles_edit',
          meta: {
            permissions: ['administrator'],
          },
          component: CustomRolesEdit,
        },
      ],
    },
  ],
};
